import { render } from "./LaporanPenyataPemungut2.vue?vue&type=template&id=3717a66b"
import script from "./LaporanPenyataPemungut2.vue?vue&type=script&lang=js"
export * from "./LaporanPenyataPemungut2.vue?vue&type=script&lang=js"

import "./LaporanPenyataPemungut2.vue?vue&type=style&index=0&id=3717a66b&lang=css"
import "./LaporanPenyataPemungut2.vue?vue&type=style&index=1&id=3717a66b&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__